import React from "react";
import styled from "styled-components";

const VersionSelectorContainer = styled.div`
  display: flex;
`;

const VersionSelectBox = styled.select`
  display: flex;
  width: 100%;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
`;

const VersionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const VersionOption = styled.option`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
`;

interface Version {
  version: string;
  effectiveDate: string;
  title: string;
  isLatest: boolean;
}

interface VersionSelectorProps {
  versions: Version[];
  onVersionChange: (version: string) => void;
}

const VersionSelector: React.FC<VersionSelectorProps> = ({
  versions,
  onVersionChange,
}) => {
  return (
    <VersionSelectorContainer>
      <VersionSelectBox>
        {versions.map((version) => (
          <VersionOption
            key={version.version}
            onClick={() => onVersionChange(version.version)}
          >
            <VersionInfo>
              <span>{version.version}</span>
            </VersionInfo>
          </VersionOption>
        ))}
      </VersionSelectBox>
    </VersionSelectorContainer>
  );
};

export default VersionSelector;
